import { Row, Col, Space, Card } from 'antd';

import DescriptionItem from '../Description/DescriptionItem';
import { usePermission } from '../../functions/permissionValidator';
import EnginesContainer from './EnginesContainer';

export default function EnginesPage() {
  const { isGlobalAdmin } = usePermission();
  const description = isGlobalAdmin()
    ? 'Available Apps on your Nominode. Hide an App to remove it from the create-task dropdown; existing tasks keep working.'
    : 'Available Apps on your Nominode.';

  return (
    <Space
      direction="vertical"
      size={'large'}
      className="apps-management-pg heading-style-02"
    >
      <Card style={{ paddingBottom: '.5rem' }} className="m-001">
        <Row align="middle">
          <Col span={24}>
            <DescriptionItem title={'Apps'} description={description} />
          </Col>
        </Row>
      </Card>
      <Card className="m-600" bodyStyle={{ padding: 0 }}>
        <EnginesContainer />
      </Card>
    </Space>
  );
}
